import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { IStorageLocal } from "namirasoft-core";
import { BudgetInputRow, BudgetRow, ChatRow, ClassifierInputRow, ClassifierRow, ConditionGroupInputRow, ConditionGroupRow, ConditionInputRow, ConditionRow, FailoverInputRow, FailoverRow, GatewayInputRow, GatewayRow, GuardRailInputRow, GuardRailRow, InteractionRow, KnowledgebaseInputRow, KnowledgebaseItemInputRow, KnowledgebaseItemRow, KnowledgebaseRow, LoadBalancerInputRow, LoadBalancerRow, MemoryInputRow, MemoryRow, ModelInputRow, ModelRow, NamirasoftInferenceMetaDatabase, RaceInputRow, RaceRow, RouterInputRow, RouterRow, ValidatorInputRow, ValidatorRow, WiperInputRow, WiperRow } from "namirasoft-inference";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, EnumFormatter, FloatFormatter, IDFormatter, IntegerFormatter, JsonFormatter, MoneyFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { InferenceMenus } from "./InferenceMenus";
import { InferenceRouterProps } from "./InferenceRouterProps";
import { InferenceRoutes } from "./InferenceRoutes";

export class InferenceEntities
{
    static model(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<ModelRow, ModelInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "model",
            tables: [{ table: inference.tables.model, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.model_company, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.model_name, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.settings, new JsonFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.model_api_key_credential_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.budget_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.memory_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.model.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.ModelList,
                getNewURL: () => InferenceRoutes.ModelNew,
                getViewURL: (id) => InferenceRoutes.ModelView(id),
                getEditURL: (id) => InferenceRoutes.ModelEdit(id),
                getCopyURL: (id) => InferenceRoutes.ModelCopy(id),
                getMenus: (getIDs) => ({
                    "Chat": [InferenceMenus.chatWithModel(props, getIDs)]
                })
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.model.List,
                get: props.servers.inference.model.Get,
                create: props.servers.inference.model.Create,
                update: props.servers.inference.model.Update,
                delete: props.servers.inference.model.Delete,
            }
        }
    }

    static load_balancer(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<LoadBalancerRow, LoadBalancerInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "load_balancer",
            tables: [{ table: inference.tables.load_balancer, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.algorithm, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.budget_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.memory_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.load_balancer.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.LoadBalancerList,
                getNewURL: () => InferenceRoutes.LoadBalancerNew,
                getViewURL: (id) => InferenceRoutes.LoadBalancerView(id),
                getEditURL: (id) => InferenceRoutes.LoadBalancerEdit(id),
                getCopyURL: (id) => InferenceRoutes.LoadBalancerCopy(id),
                getMenus: (getIDs) => ({
                    "Chat": [InferenceMenus.chatWithLoadBalancer(props, getIDs)]
                })
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.load_balancer.List,
                get: props.servers.inference.load_balancer.Get,
                create: props.servers.inference.load_balancer.Create,
                update: props.servers.inference.load_balancer.Update,
                delete: props.servers.inference.load_balancer.Delete,
            }
        }
    }

    static failover(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<FailoverRow, FailoverInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "failover",
            tables: [{ table: inference.tables.failover, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.budget_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.memory_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.failover.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.FailoverList,
                getNewURL: () => InferenceRoutes.FailoverNew,
                getViewURL: (id) => InferenceRoutes.FailoverView(id),
                getEditURL: (id) => InferenceRoutes.FailoverEdit(id),
                getCopyURL: (id) => InferenceRoutes.FailoverCopy(id),
                getMenus: (getIDs) => ({
                    "Chat": [InferenceMenus.chatWithFailover(props, getIDs)]
                })
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.failover.List,
                get: props.servers.inference.failover.Get,
                create: props.servers.inference.failover.Create,
                update: props.servers.inference.failover.Update,
                delete: props.servers.inference.failover.Delete,
            }
        }
    }

    static race(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<RaceRow, RaceInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "race",
            tables: [{ table: inference.tables.race, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.budget_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.memory_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.race.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.RaceList,
                getNewURL: () => InferenceRoutes.RaceNew,
                getViewURL: (id) => InferenceRoutes.RaceView(id),
                getEditURL: (id) => InferenceRoutes.RaceEdit(id),
                getCopyURL: (id) => InferenceRoutes.RaceCopy(id),
                getMenus: (getIDs) => ({
                    "Chat": [InferenceMenus.chatWithRace(props, getIDs)]
                })
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.race.List,
                get: props.servers.inference.race.Get,
                create: props.servers.inference.race.Create,
                update: props.servers.inference.race.Update,
                delete: props.servers.inference.race.Delete,
            }
        }
    }

    static wiper(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<WiperRow, WiperInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "wiper",
            tables: [{ table: inference.tables.wiper, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.time_type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.time_value, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.count, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.wiper.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.WiperList,
                getNewURL: () => InferenceRoutes.WiperNew,
                getViewURL: (id) => InferenceRoutes.WiperView(id),
                getEditURL: (id) => InferenceRoutes.WiperEdit(id),
                getCopyURL: (id) => InferenceRoutes.WiperCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.wiper.List,
                get: props.servers.inference.wiper.Get,
                create: props.servers.inference.wiper.Create,
                update: props.servers.inference.wiper.Update,
                delete: props.servers.inference.wiper.Delete,
            }
        }
    }

    static budget(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<BudgetRow, BudgetInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "budget",
            tables: [{ table: inference.tables.budget, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.cost_limit_per_month, new FloatFormatter(), "Cost Limit"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.cost_limit_per_week, new FloatFormatter(), "Cost Limit"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.cost_limit_per_day, new FloatFormatter(), "Cost Limit"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.cost_limit_per_chat, new FloatFormatter(), "Cost Limit"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.cost_limit_per_run, new FloatFormatter(), "Cost Limit"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_token, new IntegerFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_token_input, new IntegerFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_token_output, new IntegerFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_cost, new MoneyFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_cost_input, new MoneyFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_cost_output, new MoneyFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_monthly_started_at, new DateTimeFormatter(), "Monthly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_monthly_token, new IntegerFormatter(), "Monthly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_monthly_token_input, new IntegerFormatter(), "Monthly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_monthly_token_output, new IntegerFormatter(), "Monthly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_monthly_cost, new MoneyFormatter(), "Monthly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_monthly_cost_input, new MoneyFormatter(), "Monthly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_monthly_cost_output, new MoneyFormatter(), "Monthly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_weekly_started_at, new DateTimeFormatter(), "Weekly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_weekly_token, new IntegerFormatter(), "Weekly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_weekly_token_input, new IntegerFormatter(), "Weekly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_weekly_token_output, new IntegerFormatter(), "Weekly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_weekly_cost, new MoneyFormatter(), "Weekly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_weekly_cost_input, new MoneyFormatter(), "Weekly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_weekly_cost_output, new MoneyFormatter(), "Weekly"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_daily_started_at, new DateTimeFormatter(), "Daily"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_daily_token, new IntegerFormatter(), "Daily"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_daily_token_input, new IntegerFormatter(), "Daily"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_daily_token_output, new IntegerFormatter(), "Daily"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_daily_cost, new MoneyFormatter(), "Daily"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_daily_cost_input, new MoneyFormatter(), "Daily"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.total_daily_cost_output, new MoneyFormatter(), "Daily"),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.budget.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.BudgetList,
                getNewURL: () => InferenceRoutes.BudgetNew,
                getViewURL: (id) => InferenceRoutes.BudgetView(id),
                getEditURL: (id) => InferenceRoutes.BudgetEdit(id),
                getCopyURL: (id) => InferenceRoutes.BudgetCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.budget.List,
                get: props.servers.inference.budget.Get,
                create: props.servers.inference.budget.Create,
                update: props.servers.inference.budget.Update,
                delete: props.servers.inference.budget.Delete,
            }
        }
    }

    static memory(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<MemoryRow, MemoryInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "memory",
            tables: [{ table: inference.tables.memory, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.total_interaction, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.total_size, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.memory.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.MemoryList,
                getNewURL: () => InferenceRoutes.MemoryNew,
                getViewURL: (id) => InferenceRoutes.MemoryView(id),
                getEditURL: (id) => InferenceRoutes.MemoryEdit(id),
                getCopyURL: (id) => InferenceRoutes.MemoryCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.memory.List,
                get: props.servers.inference.memory.Get,
                create: props.servers.inference.memory.Create,
                update: props.servers.inference.memory.Update,
                delete: props.servers.inference.memory.Delete,
            }
        }
    }

    static knowledgebase(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<KnowledgebaseRow, KnowledgebaseInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "knowledgebase",
            tables: [{ table: inference.tables.knowledgebase, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.KnowledgebaseList,
                getNewURL: () => InferenceRoutes.KnowledgebaseNew,
                getViewURL: (id) => InferenceRoutes.KnowledgebaseView(id),
                getEditURL: (id) => InferenceRoutes.KnowledgebaseEdit(id),
                getCopyURL: (id) => InferenceRoutes.KnowledgebaseCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.knowledgebase.List,
                get: props.servers.inference.knowledgebase.Get,
                create: props.servers.inference.knowledgebase.Create,
                update: props.servers.inference.knowledgebase.Update,
                delete: props.servers.inference.knowledgebase.Delete,
            }
        }
    }

    static knowledgebase_item(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<KnowledgebaseItemRow, KnowledgebaseItemInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "knowledgebase_item",
            tables: [{ table: inference.tables.knowledgebase_item, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.knowledgebase_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.value, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.knowledgebase_item.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.KnowledgebaseItemList,
                getNewURL: () => InferenceRoutes.KnowledgebaseItemNew,
                getViewURL: (id) => InferenceRoutes.KnowledgebaseItemView(id),
                getEditURL: (id) => InferenceRoutes.KnowledgebaseItemEdit(id),
                getCopyURL: (id) => InferenceRoutes.KnowledgebaseItemCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.knowledgebase_item.List,
                get: props.servers.inference.knowledgebase_item.Get,
                create: props.servers.inference.knowledgebase_item.Create,
                update: props.servers.inference.knowledgebase_item.Update,
                delete: props.servers.inference.knowledgebase_item.Delete,
            }
        }
    }

    static condition(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<ConditionRow, ConditionInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "condition",
            tables: [{ table: inference.tables.condition, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.not, new BooleanFormatter("Yes", "No")),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.operator, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.if_text_contains_any_words, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.if_text_contains_all_words, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.if_length_greater_than, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.if_length_less_than, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.if_classifier_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.if_classifier_contains_any_classes, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.if_classifier_contains_all_classes, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.if_contains_any_tags, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.if_contains_all_tags, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.ConditionList,
                getNewURL: () => InferenceRoutes.ConditionNew,
                getViewURL: (id) => InferenceRoutes.ConditionView(id),
                getEditURL: (id) => InferenceRoutes.ConditionEdit(id),
                getCopyURL: (id) => InferenceRoutes.ConditionCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.condition.List,
                get: props.servers.inference.condition.Get,
                create: props.servers.inference.condition.Create,
                update: props.servers.inference.condition.Update,
                delete: props.servers.inference.condition.Delete,
            }
        }
    }

    static condition_group(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<ConditionGroupRow, ConditionGroupInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "condition_group",
            tables: [{ table: inference.tables.condition_group, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.not, new BooleanFormatter("Yes", "No")),
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.operator, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.condition_group.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.ConditionGroupList,
                getNewURL: () => InferenceRoutes.ConditionGroupNew,
                getViewURL: (id) => InferenceRoutes.ConditionGroupView(id),
                getEditURL: (id) => InferenceRoutes.ConditionGroupEdit(id),
                getCopyURL: (id) => InferenceRoutes.ConditionGroupCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.condition_group.List,
                get: props.servers.inference.condition_group.Get,
                create: props.servers.inference.condition_group.Create,
                update: props.servers.inference.condition_group.Update,
                delete: props.servers.inference.condition_group.Delete,
            }
        }
    }

    static classifier(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<ClassifierRow, ClassifierInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "classifier",
            tables: [{ table: inference.tables.classifier, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.inferencer_type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.inferencer_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.additional_prompt, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.multiple, new BooleanFormatter("Yes", "No")),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.memory_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.classifier.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.ClassifierList,
                getNewURL: () => InferenceRoutes.ClassifierNew,
                getViewURL: (id) => InferenceRoutes.ClassifierView(id),
                getEditURL: (id) => InferenceRoutes.ClassifierEdit(id),
                getCopyURL: (id) => InferenceRoutes.ClassifierCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.classifier.List,
                get: props.servers.inference.classifier.Get,
                create: props.servers.inference.classifier.Create,
                update: props.servers.inference.classifier.Update,
                delete: props.servers.inference.classifier.Delete,
            }
        }
    }

    static validator(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<ValidatorRow, ValidatorInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "validator",
            tables: [{ table: inference.tables.validator, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.expected_format, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.example_format, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.on_invalid_action, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.error_message, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.corrector_inferencer_type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.corrector_inferencer_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.retry_count, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.additional_prompt, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.memory_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.validator.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.ValidatorList,
                getNewURL: () => InferenceRoutes.ValidatorNew,
                getViewURL: (id) => InferenceRoutes.ValidatorView(id),
                getEditURL: (id) => InferenceRoutes.ValidatorEdit(id),
                getCopyURL: (id) => InferenceRoutes.ValidatorCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.validator.List,
                get: props.servers.inference.validator.Get,
                create: props.servers.inference.validator.Create,
                update: props.servers.inference.validator.Update,
                delete: props.servers.inference.validator.Delete,
            }
        }
    }

    static guard_rail(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<GuardRailRow, GuardRailInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "guard_rail",
            tables: [{ table: inference.tables.guard_rail, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.memory_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.guard_rail.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.GuardRailList,
                getNewURL: () => InferenceRoutes.GuardRailNew,
                getViewURL: (id) => InferenceRoutes.GuardRailView(id),
                getEditURL: (id) => InferenceRoutes.GuardRailEdit(id),
                getCopyURL: (id) => InferenceRoutes.GuardRailCopy(id),
                getMenus: () => ({})
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.guard_rail.List,
                get: props.servers.inference.guard_rail.Get,
                create: props.servers.inference.guard_rail.Create,
                update: props.servers.inference.guard_rail.Update,
                delete: props.servers.inference.guard_rail.Delete,
            }
        }
    }

    static router(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<RouterRow, RouterInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "router",
            tables: [{ table: inference.tables.router, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.default_inferencer_type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.default_inferencer_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.budget_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.memory_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.router.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.RouterList,
                getNewURL: () => InferenceRoutes.RouterNew,
                getViewURL: (id) => InferenceRoutes.RouterView(id),
                getEditURL: (id) => InferenceRoutes.RouterEdit(id),
                getCopyURL: (id) => InferenceRoutes.RouterCopy(id),
                getMenus: (getIDs) => ({
                    "Chat": [InferenceMenus.chatWithRouter(props, getIDs)]
                })
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.router.List,
                get: props.servers.inference.router.Get,
                create: props.servers.inference.router.Create,
                update: props.servers.inference.router.Update,
                delete: props.servers.inference.router.Delete,
            }
        }
    }

    static gateway(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<GatewayRow, GatewayInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "gateway",
            tables: [{ table: inference.tables.gateway, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.inferencer_type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.inferencer_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.validator_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.budget_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.memory_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.wiper_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.description, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.gateway.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.GatewayList,
                getNewURL: () => InferenceRoutes.GatewayNew,
                getViewURL: (id) => InferenceRoutes.GatewayView(id),
                getEditURL: (id) => InferenceRoutes.GatewayEdit(id),
                getCopyURL: (id) => InferenceRoutes.GatewayCopy(id),
                getMenus: (getIDs) => ({
                    "Chat": [InferenceMenus.chatWithGateway(props, getIDs)]
                })
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.gateway.List,
                get: props.servers.inference.gateway.Get,
                create: props.servers.inference.gateway.Create,
                update: props.servers.inference.gateway.Update,
                delete: props.servers.inference.gateway.Delete,
            }
        }
    }

    static chat(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<ChatRow, ChatRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "chat",
            tables: [{ table: inference.tables.chat, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.inferencer_type, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.inferencer_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.name, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.total_token, new IntegerFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.total_token_input, new IntegerFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.total_token_output, new IntegerFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.total_cost, new MoneyFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.total_cost_input, new MoneyFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.total_cost_output, new MoneyFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.chat.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.ChatList,
                getNewURL: null,
                getViewURL: (id) => InferenceRoutes.ChatView(id),
                getEditURL: null,
                getCopyURL: null,
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.chat.List,
                get: props.servers.inference.chat.Get,
                create: null,
                update: null,
                delete: null,
            }
        }
    }

    static interaction(props: NSARouterMakerResult & InferenceRouterProps): IEntityInfo<InteractionRow, InteractionRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_INFERENCE,
            name: "interaction",
            tables: [{ table: inference.tables.interaction, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.chat_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.run_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.model_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.model_provider, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.model_name, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.message_user, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.message_ai, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.message_error, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.status, new EnumFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.total_token, new IntegerFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.total_token_input, new IntegerFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.total_token_output, new IntegerFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.total_cost, new MoneyFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.total_cost_input, new MoneyFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.total_cost_output, new MoneyFormatter(), "Total"),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.duration, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.metadata, new StringFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.winner, new BooleanFormatter("Yes", "No")),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(inference.tables.interaction.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => InferenceRoutes.InteractionList,
                getNewURL: null,
                getViewURL: (id) => InferenceRoutes.InteractionView(id),
                getEditURL: null,
                getCopyURL: null,
            },
            server: {
                value_list: props.servers.inference.value.List,
                list: props.servers.inference.interaction.List,
                get: props.servers.inference.interaction.Get,
                create: null,
                update: null,
                delete: null,
            }
        }
    }
}